import dayjs from 'dayjs';

import { dateLocales, Locale } from '../config/locales';
import { DateInput } from '../types';

export const toWeekDayAndDateString = ({ date, locale = 'bg' }: { date: DateInput; locale?: Locale }) =>
  dayjs(date).locale(dateLocales[locale]).format('dddd, D-MM-YYYY');
